import { observer } from 'mobx-react';
import * as React from 'react';
import { SpeechData } from '../stores';
import { MediaItem } from './MediaItem';
import { Videos } from './Videos';

interface Props {
    data: SpeechData,
    path?: string
}

@observer
export class Media extends React.Component<Props> {
    render() {
        const { data, path } = this.props;
        return (
            <div>
                <Videos data={data} path={path} />

                <ul>
                    {data.Media.map(media => (
                        <MediaItem key={media.type+media.link} data={media} />
                    ))}
                </ul>
            </div>
        );
    }
}

